export default __webpack_public_path__ + "static/media/preconceito.280c3b26.svg";